import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { NewUserDetailsComponent } from './new-user-details.component';
import { AlgoTravelPreferencesModule } from '../algo-travel-preferences/algo-travel-preferences.module';
import { AlgoTravelPreferencesComponent } from '../algo-travel-preferences/algo-travel-preferences.component';

const routes: Routes = [{ path: '', component: NewUserDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewUserDetailsRoutingModule {}

@NgModule({
  imports: [
    NewUserDetailsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    AlgoTravelPreferencesModule,
  ],
  declarations: [NewUserDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NewUserDetailsModule {}
